<template>
    <div>

        <div class="value-field-container" :class="{ 'value-field-container-slide-in': slideIn }" @click="cheat">
            <div class="value-field-header">
                <div v-html="headerText"></div>
                <AvatarCircle class="value-field-header-avatar-circle" :id="user" :size="61" :sizeInner="45">
                </AvatarCircle>
            </div>
            <ValueField TKey="label_bank_balance" IconClass="icon-bank-balance" :Value="displayBankBalance"
                :AlwaysShowValue="true"></ValueField>
            <ValueField TKey="label_house_value" IconClass="icon-property-value" :Hide="isMarae"
                :Value="ownedPropertyValue">
            </ValueField>
            <ValueField TKey="label_total_worth" IconClass="icon-total-worth" :Hide="isMarae"
                :Value="ownedPropertyValue + bankBalance"></ValueField>
            <div v-if="showDonate" @click="$emit('open-donate')" class="button btn-donate" v-html="T('button_donate')">
            </div>
            <div class="slot-container no-click">
                <slot></slot>
            </div>
        </div>


        <!-- https://rotato.app/blog/transparent-videos-for-the-web -->
        <video v-if="showCoinsCounter" v-bind:key="'showCoinsCounter' + showCoinsCounter" class="coin-anim"
            autoplay="autoplay" muted="muted" playsinline="playsinline">
            <source :src="publicPath + './videos/coins.mov'" type='video/mp4; codecs="hvc1"'>
            <source :src="publicPath + './videos/coins.webm'" type="video/webm">
        </video>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ValueField from './ValueField.vue';
import { T } from '@/App.vue';
import { users } from '../../../shared_fca/room_user';
import AvatarCircle from './AvatarCircle.vue';

class DashboardHeaderData {
    displayBankBalance = 0;
    lastTimeStamp = 0;
    showCoinsCounter = 0;
    isShowingCoins = false;
}

export default Vue.extend({
    name: 'DashboardHeader',
    data() {
        return new DashboardHeaderData();
    },
    props: {
        ownedPropertyValue: Number,
        bankBalance: Number,
        isMarae: Boolean,
        showDonate: Boolean,
        slideIn: Boolean,
        user: String,
    },
    components: { ValueField, AvatarCircle },
    computed: {

        publicPath: {
            cache: false,
            get(): string {
                return process.env.BASE_URL ?? "";
            }
        },

        headerText: {
            cache: false,
            get(): string {

                const myUser = users[this.user];

                return T(myUser.realname) + "'s " + T("financials");
            }
        }

    },
    created() {
        this.onFrame(0);
    },
    methods: {

        T(key: string): string {
            return T(key);
        },

        cheat() {
            this.$emit("cheat");
        },

        onFrame(timeStamp: number) {

            let timePassed = 0;
            if (this.lastTimeStamp > 0) {
                timePassed = (timeStamp - this.lastTimeStamp) * 0.002;
            }
            this.lastTimeStamp = timeStamp;

            if (this.displayBankBalance > this.bankBalance) {
                //Count down
                const delta = (this.bankBalance - this.displayBankBalance) * timePassed;
                this.displayBankBalance += Math.floor(delta);
                if (this.isShowingCoins == false) {
                    this.isShowingCoins = true;
                    this.showCoinsCounter += 1;
                }
            }
            else {
                this.displayBankBalance = this.bankBalance;
                this.isShowingCoins = false;
            }

            window.requestAnimationFrame((t) => this.onFrame(t));
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.slot-container {
    position: absolute;
    width: 100%;
    height: 100%;
}

.value-field-container {
    position: absolute;
    left: 7px;
    top: 113px;
    width: 221.25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.value-field-container-slide-in {
    animation: value-field-container-anim 1s
}

.btn-donate {
    background-color: #B2CD30;
    border-radius: 8px;
    width: 181px;
    height: 44px;
    margin-top: 4px;
    margin-left: -14px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: white;
    padding-left: 16px;
}

@keyframes value-field-container-anim {
    0% {
        left: -221.25px;
    }

    100% {
        left: 7px;
    }
}

.coin-anim {
    position: absolute;
    top: 85px; //115
    left: 155px; //175
    width: 312px; //156
    height: 316px; //158
}

.value-field-header {
    width: 165px;
    height: 44px;
    border-radius: 8px;
    background-color: #BFBEA5;
    margin-bottom: 12px;
    padding-left: 59px;
    padding-right: 20px;
    padding-top: 7px;
    font-family: Rubik;
    font-weight: 700;
    font-size: 15px;
    line-height: 16px;
    letter-spacing: 0.01px;
    color: #636252;
}

.value-field-header-avatar-circle {
    position: absolute;
    left: 13px;
    top: -9px;
}
</style>